(function ($)
{
	window.InteractiveChartInputs = function () {
	
	};
	//Constants
	InteractiveChartInputs.prototype.WIDTH = 800;
	//Public
	InteractiveChartInputs.prototype.Get = function () {
		return this._data;
	};
	///Sets necessary data from output of chart
})(jQuery);